"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
class Api {
    constructor(makeGetCall, makePostCall, onError, baseUrl = '') {
        this.endpoints = [];
        const errorHandler = onError || console.log;
        this.http = {
            get: (url, nativeProcessing) => makeGetCall(baseUrl + url, nativeProcessing).then(result => result, (e) => { errorHandler(e); return null; }),
            post: (url, data, nativeProcessing) => makePostCall(baseUrl + url, data, nativeProcessing).then(result => result, (e) => { errorHandler(e); return null; })
        };
    }
    static getRouter() {
        const invalid = () => { throw Error('Not a valid API'); };
        return new Api(invalid, invalid);
    }
    use(endpoint) {
        this.endpoints.push(endpoint);
        return endpoint.addTo(this);
    }
    useRouter(router) {
        for (const endpoint of router.endpoints) {
            this.endpoints.push(endpoint);
            endpoint.addTo(this);
        }
        return this;
    }
}
exports.Api = Api;
